export const ELECTRIC_RETAIL_MAPTILES_DIRECTORY = 'infrastructure_service_area';
export const ELECTRIC_RETAIL_SOURCE_DATA_LAYER = 'service_areas';

export const ELECTRIC_RETAIL_LAYER_ID = 'electric-retail-service-layer';

export const ELECTRIC_RETAIL_LAYER_COLOR = '#3885BA';
export const ELECTRIC_RETAIL_LAYER_OPACITY = 0.6;

export const MIN_ZOOM_VISIBILITY = 6;
